// Subscription utility functions

export const SUBSCRIPTION_LIMITS = {
  FREE: {
    mockTests: 3,
    practiceQuestions: 50,
    type: 'free'
  },
  PREMIUM: {
    mockTests: Infinity,
    practiceQuestions: Infinity,
    type: 'premium'
  }
};

// Check if user is premium
export const isPremiumUser = (user) => {
  if (user && user.subscription === 'premium') {
    return true;
  }
  return false;
};

// Get user's subscription type from AuthContext
export const getUserSubscription = (user) => {
  if (!user) return 'free';
  return user.subscription || 'free';
};

// Check if user can access a specific mock test
export const canAccessMockTest = (user, testId) => {
  if (isPremiumUser(user)) {
    return true;
  }
  // Free users can only access first 3 mock tests
  return testId <= SUBSCRIPTION_LIMITS.FREE.mockTests;
};

// Get limited questions for practice based on subscription
export const getLimitedQuestions = (questions, user) => {
  if (isPremiumUser(user)) {
    return questions;
  }
  // Free users get only first 50 questions
  return questions.slice(0, SUBSCRIPTION_LIMITS.FREE.practiceQuestions);
};

// Get accessible mock tests based on subscription
export const getAccessibleMockTests = (tests, user) => {
  if (isPremiumUser(user)) {
    return tests;
  }
  // Free users get only first 3 mock tests
  return tests.slice(0, SUBSCRIPTION_LIMITS.FREE.mockTests);
};

// Check if question is locked
export const isQuestionLocked = (questionIndex, user) => {
  if (isPremiumUser(user)) {
    return false;
  }
  return questionIndex >= SUBSCRIPTION_LIMITS.FREE.practiceQuestions;
};

// Check if mock test is locked
export const isMockTestLocked = (testId, user) => {
  if (isPremiumUser(user)) {
    return false;
  }
  return testId > SUBSCRIPTION_LIMITS.FREE.mockTests;
};

// Get remaining count for free users
export const getRemainingCount = (user, type = 'questions') => {
  if (isPremiumUser(user)) {
    return Infinity;
  }
  
  if (type === 'questions') {
    return SUBSCRIPTION_LIMITS.FREE.practiceQuestions;
  } else if (type === 'tests') {
    return SUBSCRIPTION_LIMITS.FREE.mockTests;
  }
  return 0;
};

// Prevent downgrade from premium subscription
export const canDowngradeSubscription = (currentSubscription) => {
  // Premium users cannot downgrade
  if (currentSubscription === 'premium') {
    return false;
  }
  // Free users can upgrade
  return true;
};
